<script lang="ts">
	//Hooks
	import { createEventDispatcher } from 'svelte';
	//Helpers
	import { getAddonStatus } from '../../helpers/addons/addon_helpers';
	import { getExtSensorsStatus } from '../../helpers/ext_sensor_helpers';
	import { real_id } from 'src/helpers/interface_helpers';
	//Stores
		import { getDeviceStatus, getDeviceSettings, readDeviceStatus } from 'src/stores/device-runtime/status-selectors';
	//Design system components
	import { ControlsContainer, ListItem, Stack, Text } from '@Shelly/shelly-design-system';
	//Types
	import type { Device } from '../../types/Device';
	import { format } from 'svelte-i18n';

	$: statusStore = getDeviceStatus(device.id);
	export let device: Device;
	export let isGen2 = false;

	const dispatch = createEventDispatcher();

	let peripherals = [];
	$: if ($statusStore?.online) {
		peripherals = isGen2
			? getAddonStatus(device, [], false, true).filter((i) => i.peripheralType != 'lora')
			: getExtSensorsStatus(device);
	}
</script>

{#if peripherals.length}
	<ControlsContainer size="s" class="mb-s ">
		<svelte:fragment slot="first">
			<Text element="p" class="text-bold mb-s">
				{isGen2
					? $format('settings_title_addon_sensors', {
							default: 'Add-on peripherals',
						})
					: $format('label_external_sensors', {
							default: 'External sensors',
						})}
			</Text>

			<Stack gap="xs">
				<!-- svelte-ignore a11y-click-events-have-key-events -->
				{#each peripherals as item, i}
					<div
						role="presentation"
						style="cursor: pointer;"
						on:click={() => {
							dispatch(
								'click',
								`${item.sensor.type}${
									['temperature', 'humidity'].includes(item.sensor.type)
										? ''
										: '_' + item.sensor.extid
								}`,
							);
						}}
					>
						<ListItem
							icon={item.icon}
							title={item.sensor.name}
							progress={{
								title: item.value,
							}}
						/>
					</div>
				{/each}
			</Stack>
		</svelte:fragment>
	</ControlsContainer>
{/if}
